import actions from './actions'
import mutations from './mutations'
import getters from './getters'

export default {
  namespaced: true,
  state() {
    return {
      current_analytics_dashboard: null
    }
  },
  getters,
  actions,
  mutations
}
